import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rightArrow",
  "use": "icon-rightArrow-usage",
  "viewBox": "0 0 7.071 11.314",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7.071 11.314\" id=\"icon-rightArrow\">\n    <g data-name=\"组 7494\" transform=\"translate(-901.268 3667.107)\">\n        <rect data-name=\"矩形 2403\" width=\"8\" height=\"2\" rx=\"1\" transform=\"rotate(45 4877.93 -743.92)\" style=\"fill:#000\" />\n        <rect data-name=\"矩形 2405\" width=\"8\" height=\"2\" rx=\"1\" transform=\"rotate(-45 -3964.005 -2916.53)\" style=\"fill:#000\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol